import { IsNotEmpty, IsOptional, IsString, IsBoolean, ValidateIf } from 'class-validator';

export class ImportUsersDto {
	@IsOptional()
	@IsString()
	phoneFieldName?: string;

	@IsOptional()
	@IsString()
	emailFieldName?: string;

	@IsOptional()
	@IsString()
	fullNameFieldName?: string;

	@IsOptional()
	@IsString()
	homeAddressNameFieldName?: string;

	@IsOptional()
	@IsString()
	communityIdToFollow?: string;

	@ValidateIf(o => o.eventPriceFieldName && o.eventPriceFieldName.trim() !== '')
	@IsNotEmpty()
	@IsString()
	eventBaseId?: string;

	@ValidateIf(o => o.eventPriceFieldName && o.eventPriceFieldName.trim() !== '')
	@IsNotEmpty({ message: 'Event is required when Event Price Tier Column Name is provided' })
	@IsString()
	eventInstance?: string;

	@IsOptional()
	@IsString()
	eventPriceFieldName?: string;

	@IsOptional()
	@IsString()
	eventIntakeFormMapping?: Record<any, any>; // [intake form field name]: <csv column name>

	@IsOptional()
	@IsString()
	membershipId?: string;

	@IsOptional()
	@IsBoolean()
	membershipRechargeNeeded?: boolean;

	@IsOptional()
	@IsString()
	membershipNextChargeAmountFieldName?: string; // amount in cents; will be charged on membershipActualToFieldName if membershipRechargeNeeded = true

	@IsOptional()
	@IsString()
	membershipTierFieldName?: string;

	@IsOptional()
	@IsString()
	membershipActualFromFieldName?: string;

	@IsOptional()
	@IsString()
	membershipActualToFieldName?: string; // next charge will be done on this date if membershipRechargeNeeded = true
}
